export default __webpack_public_path__ + "static/media/untitled-22.4ac4d4e8.jpg";